import { TEST_RECORD_BLOCK_MESSAGE } from "@src/utils/test-record-utils";
import { styled } from "@uhg-abyss/web/tools/styled";
import { IconSymbol } from "@uhg-abyss/web/ui/IconSymbol";
import { Text } from "@uhg-abyss/web/ui/Text";
import type { FC } from "react";

const BannerHolder = styled("div", {
  display: "flex",
  alignItems: "center",
  gap: "8px",
  width: "100%",
  padding: "12px 16px",
  borderRadius: "8px",
  border: "1px solid $app.color.text.status.error",
});

/**
 * Renders red error text explaining that scheduling is disabled for a
 * Salesforce test lead. Used on Find Provider and Provider Profile.
 * Renders nothing unless `visible` is true.
 */
export const TestRecordBanner: FC<{ visible: boolean }> = ({ visible }) => {
  if (!visible) {
    return null;
  }

  return (
    <BannerHolder
      role="alert"
      id="obc-test-record-banner"
      data-obc-label="Test record scheduling blocked banner"
      data-testid="test-id-test-record-banner"
    >
      <IconSymbol icon="error" variant="outlined" color="$app.color.text.status.error" size={20} />
      <Text
        css={{
          color: "$app.color.text.status.error",
          fontSize: "14px",
          fontWeight: "500",
        }}
      >
        {TEST_RECORD_BLOCK_MESSAGE}
      </Text>
    </BannerHolder>
  );
};

export default TestRecordBanner;
